import { debounce } from '@mui/material';
import { useEffect, useRef, useState } from 'react';

export function useDebounce<T>(currentValue: T, time: number) {
  const [value, setValue] = useState<T>(currentValue);
  const setDebounceValue = useRef<(value: T) => void>(undefined);
  if (typeof setDebounceValue.current === 'undefined') {
    setDebounceValue.current = debounce(setValue, time);
  }

  useEffect(() => setDebounceValue.current?.(currentValue), [currentValue]);

  return value;
}
